import { CaretDownOutlined, CaretUpOutlined } from '@ant-design/icons';
import { Col, Row } from 'antd';
import { secondsToHms } from '../common/Common';
import { useState } from 'react';

const IQ3KouteiBetsuKesanshiki_Shirring = (props) => {
  const [isProcessDetailOpen, setIsProcessDetailOpen] = useState(true);
  const isOpen = () => {
    if (isProcessDetailOpen) {
      setIsProcessDetailOpen(false);
    } else {
      setIsProcessDetailOpen(true);
    }
  };
  return (
    <div className="kouteiCalculateDiv" id="kouteiCalculateDivID">
      <Row style={{ width: '100%', borderBottom: '1px solid #eee', cursor: 'pointer' }}>
        <Col span={4} style={{ paddingLeft: 40, paddingTop: 10 }}>
          <div
            style={{
              borderBottom: '2px solid #eeebeb',
              paddingBottom: 4,
            }}
          >
            <label>{'段取時間'}</label>
          </div>

          <div
            style={{
              borderBottom: '2px solid #eeebeb',
              paddingBottom: 4,
            }}
          >
            <label>{'段取金額'}</label>
          </div>
        </Col>
        <Col span={12} style={{ paddingTop: 10 }}>
          <div
            style={{
              borderBottom: '2px solid #eeebeb',
              paddingBottom: 4,
            }}
          >
            <label>{'基本段取時間'}</label>
          </div>

          <div
            style={{
              borderBottom: '2px solid #eeebeb',
              paddingBottom: 4,
            }}
          >
            <label>{'段階時間＊時間チャージ'}</label>
          </div>
        </Col>
        <Col span={8} style={{ paddingTop: 10 }}>
          <div
            style={{
              borderBottom: '2px solid #eeebeb',
              paddingBottom: 4,
            }}
          >
            <label>{`${props?.dandoriTimeSec} (${secondsToHms(props?.dandoriTimeSec)})`}</label>
          </div>

          <div
            style={{
              borderBottom: '2px solid #eeebeb',
              paddingBottom: 4,
            }}
          >
            <label>{`${props?.dandoriTimeSec} * ${props?.mSetHRate} = ${props?.dandoriAmt}`}</label>
          </div>
        </Col>
      </Row>
      <Row style={{ width: '100%', borderBottom: '1px solid #eee', cursor: 'pointer' }} onClick={() => isOpen()}>
        <Col span={4} style={{ paddingLeft: 20 }}>
          {isProcessDetailOpen ? (
            <CaretUpOutlined style={{ fontSize: 18, marginTop: 5 }} />
          ) : (
            <CaretDownOutlined style={{ fontSize: 18, marginTop: 5 }} />
          )}
          <label style={{ marginLeft: 5 }}>{'加工金額/時間'}</label>
        </Col>
      </Row>
      <div
        style={{
          display: isProcessDetailOpen ? 'block' : 'none',
          marginLeft: 10,
        }}
      >
        <Row style={{ width: '100%', borderBottom: '1px solid #eee', cursor: 'pointer' }}>
          <Col span={4} style={{ paddingLeft: 40, paddingTop: 10 }}>
            <div
              style={{
                borderBottom: '2px solid #eeebeb',
                paddingBottom: 4,
              }}
            >
              <label>{'加工時間'}</label>
            </div>

            <div
              style={{
                borderBottom: '2px solid #eeebeb',
                paddingBottom: 4,
              }}
            >
              <label>{'加工金額'}</label>
            </div>

            <div
              style={{
                borderBottom: '2px solid #eeebeb',
                paddingBottom: 4,
              }}
            >
              <label>{'カット数'}</label>
            </div>

            <div
              style={{
                borderBottom: '2px solid #eeebeb',
                paddingBottom: 4,
              }}
            >
              <label>{'1カット加工時間'}</label>
            </div>
          </Col>
          <Col span={12} style={{ paddingTop: 10 }}>
            <div
              style={{
                borderBottom: '2px solid #eeebeb',
                paddingBottom: 4,
              }}
            >
              <label>{'1カット時間＊カット数'}</label>
            </div>

            <div
              style={{
                borderBottom: '2px solid #eeebeb',
                paddingBottom: 4,
              }}
            >
              <label>{'作業時間＊時間チャージ'}</label>
            </div>

            <div
              style={{
                borderBottom: '2px solid #eeebeb',
                paddingBottom: 4,
              }}
            >
              <label>{'カット数'}</label>
            </div>

            <div
              style={{
                borderBottom: '2px solid #eeebeb',
                paddingBottom: 4,
              }}
            >
              <label>{'1カット加工時間'}</label>
            </div>
          </Col>
          <Col span={8} style={{ paddingTop: 10 }}>
            <div
              style={{
                borderBottom: '2px solid #eeebeb',
                paddingBottom: 4,
              }}
            >
              <label>
                {`${props?.cutTime} * ${props?.processCount} = ${props?.dandoriTimeSec} (${secondsToHms(
                  props?.dandoriTimeSec
                )})`}
              </label>
            </div>

            <div
              style={{
                borderBottom: '2px solid #eeebeb',
                paddingBottom: 4,
              }}
            >
              <label>{`${props?.dandoriTimeSec} * ${props?.mWorkHRate} = ${props?.dandoriAmt}`}</label>
            </div>

            <div
              style={{
                borderBottom: '2px solid #eeebeb',
                paddingBottom: 4,
              }}
            >
              <label>{`${props?.processCount}`}</label>
            </div>

            <div
              style={{
                borderBottom: '2px solid #eeebeb',
                paddingBottom: 4,
              }}
            >
              <label>{`${props?.cutTime}`}</label>
            </div>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default IQ3KouteiBetsuKesanshiki_Shirring;
